import React, {Fragment} from 'react'
import {connect} from 'dva'
import {routerRedux} from 'dva/router'
import {Card, Col, Row} from 'antd'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCalendarAlt, faHome, faUsers} from '@fortawesome/free-solid-svg-icons'

import styles from "./index.module.less"
import {footerText} from "../../utils/config"
import logo from "../../assets/logo.png"

const colProps = {
  md: {span: 8}
}

const {Meta} = Card

const Home = ({
                home,
                loading,
                dispatch,
              }) => {

  const {} = home

  const handleGroupApply = () => {
    dispatch(routerRedux.push({
      pathname: 'group-apply',
    }))
  }

  const handleTicket = () => {
    dispatch(routerRedux.push({
      pathname: 'ticket/guide',
    }))
  }

  return (
    <Fragment>
      <div className={styles.header}>
        <div className={styles.logo}><img alt='logo' src={logo}/></div>
      </div>
      <div className={styles.main}>
        <Row gutter={[24, 24]}>
          <Col {...colProps}>
            <a href="http://www.csnbgsh.cn/">
              <Card bordered={false} hoverable>
                <h3 style={{backgroundColor: '#30c39e'}}><FontAwesomeIcon icon={faHome}/></h3>
                <Meta title="进入官网" description="公司官网内容展示请点击进入"/>
              </Card>
            </a>
          </Col>
          <Col {...colProps}>
            <Card bordered={false} hoverable onClick={handleGroupApply}>
              <h3 style={{backgroundColor: '#f85a40'}}><FontAwesomeIcon icon={faUsers}/></h3>
              <Meta title="团队预约" description="专项团队预约请点击进入"/>
            </Card>
          </Col>
          <Col {...colProps}>
            <Card bordered={false} hoverable onClick={handleTicket}>
              <h3 style={{backgroundColor: '#0389ff'}}><FontAwesomeIcon icon={faCalendarAlt}/></h3>
              <Meta title="网上售票" description="进行网上购票系统请点击进入"/>
            </Card>
          </Col>
        </Row>
      </div>
      <div className={styles.footer}>
        <div>{footerText}</div>
        <a href="https://beian.miit.gov.cn" target="_blank"> 沪ICP备10031748号-19 </a>
        <div>沪公网安备 31000099763-22003</div>
      </div>
    </Fragment>
  )
}

export default connect(({home, loading}) => ({
  loading,
  home,
}))(Home)
